import { render, staticRenderFns } from "./ReceivePrintDetails.vue?vue&type=template&id=7c73728c&"
import script from "./ReceivePrintDetails.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports